import 'css-chunk:src/index/components/division_selector/index.module.scss';export default {
  "tablet": "tablet__QVgWd",
  "sp": "sp__Ufjpk",
  "pc": "pc__O-X2l",
  "pcTablet": "pcTablet__8icTX",
  "section": "section__Xcnf9",
  "relative": "relative__AxZoE",
  "row": "row__OuZHX",
  "middle": "middle__MXDBn",
  "formLabel": "formLabel__-Zw5n",
  "formLabel2": "formLabel2__OXAE5",
  "formLabelIssue": "formLabelIssue__Q1clQ"
};